var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageHeader',{attrs:{"title":_vm.fieldName,"icon":"mdi-flower-outline","back":""},on:{"back":_vm.toField}},[_c('v-btn',{attrs:{"color":"error","block":""},on:{"click":_vm.deleteField}},[_vm._v(" "+_vm._s(_vm.$t('delete'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }